import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// react
import styled from 'styled-components';
// components
import { Button, Container, Icon, Card } from "../../atoms";
import { BackButton, FloatingActions } from "../../molecules";
/**
 * AttendanceAllowanceSuccessPage page is displayed when the user has successfully submitted the Attendance Allowance form.
 */
export const AttendanceAllowanceSuccess = ({ name, toBack, handlePrintPdf, }) => {
    return (_jsxs(MainWrapper, { children: [_jsx(BackButton, { variant: 'link' }), _jsx(TitleWrapper, { children: _jsxs(StyledTitle, { children: [name, "'s Attendance Allowance"] }) }), _jsx(Container, Object.assign({ size: 'md' }, { children: _jsxs(Wrapper, { children: [_jsxs(WrapperHeader, { children: [_jsx(ImageWrapper, { children: _jsx(Icon, { icon: 'truck-fast', fontSize: 42 }) }), _jsx(HeaderTitle, { children: " Your printed form is on its way to you!" })] }), _jsx(Card, Object.assign({ color: 'blue', isBordered: false }, { children: _jsxs(Content, { children: [_jsx(ContentTitle, { children: "Your next steps" }), _jsx("table", { children: _jsxs("tbody", { children: [_jsxs("tr", { children: [_jsx(StyledTd, { children: _jsx(StyledIcon, { icon: 'envelope-open-text', fontSize: 22 }) }), _jsx(StyledTd, { children: "Wait for your printed form to arrive by 1st class post. This will arrive at your loved one\u2019s address provided in the form." })] }), _jsxs("tr", { children: [_jsx(StyledTd, { children: _jsx(StyledIcon, { icon: 'pen-field', fontSize: 22 }) }), _jsxs(StyledTd, { children: ["Sign the form with a pen, on page 28 under", ' ', _jsxs(DarkText, { children: [' ', _jsx("i", { children: "Declaration" }), ". This can either be signed directly by your loved one, or by you as the caregiver (if you have power of attorney)."] }), ' '] })] }), _jsxs("tr", { children: [_jsx(StyledTd, { children: _jsx(StyledIcon, { icon: 'folder-open', fontSize: 22 }) }), _jsxs(StyledTd, { children: ["Collect any supporting evidence for your application.", ' ', _jsx(LinkButton, Object.assign({ variant: 'link', size: 'lg', isInline: true, ariaLabel: 'here', to: '/library/special-rules-for-attendance-allowance' }, { children: "Here" })), ' ', "are some tips on finding your evidence."] })] }), _jsxs("tr", { children: [_jsx(StyledTd, { children: _jsx(StyledIcon, { icon: 'mailbox', fontSize: 22 }) }), _jsx(StyledTd, { children: "Place the form and supporting evidence in your Freepost envelope and deliver to the post box. You do not need a postcode or a stamp." })] }), _jsxs("tr", { children: [_jsx(StyledTd, { children: _jsx(StyledIcon, { icon: 'calendar-check', fontSize: 22 }) }), _jsx(StyledTd, { children: "Wait for 30 days to hear about your claim from the Department of Work and Pensions. If the claim is made under the special rules for end of life, it will usually be dealt with within 2 weeks." })] }), _jsxs("tr", { children: [_jsx(StyledTd, { children: _jsx(StyledIcon, { icon: 'phone', fontSize: 22 }) }), _jsxs(StyledTd, { children: ["You can check your application\u2019s status by calling the government attendance allowance helpline on", ' ', _jsx(PhoneNumber, Object.assign({ href: 'tel:08007310122' }, { children: "0800 731 0122" }))] })] })] }) })] }) }), 'card-content'), _jsx(FloatingActions, { actions: [
                                {
                                    label: 'Back',
                                    onPress: toBack,
                                    variant: 'secondary',
                                },
                                {
                                    label: 'Download Form',
                                    onPress: handlePrintPdf,
                                },
                            ] })] }) }))] }));
};
const MainWrapper = styled.div `
  margin-bottom: ${(props) => props.theme.spacing[56]};
`;
const TitleWrapper = styled.div `
  wigth: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[16]};
  border-bottom: 1px solid ${(props) => props.theme.color.neutral[30]};
`;
const WrapperHeader = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${(props) => props.theme.spacing[16]};
  margin-top: ${(props) => props.theme.spacing[20]};
  margin-bottom: ${(props) => props.theme.spacing[16]};
`;
const HeaderTitle = styled.div `
  color: ${(props) => props.theme.color.neutral[100]};
  font: ${(props) => props.theme.typography.heading['3xl']};
`;
const StyledTitle = styled.div `
  color: ${(props) => props.theme.color.primary[80]};
  font: ${(props) => props.theme.typography.heading['4xl']};
  margin-bottom: ${(props) => props.theme.spacing[48]};
  margin-left: ${(props) => props.theme.spacing[20]};
`;
const StyledTd = styled.td `
  vertical-align: top;
  padding-right: ${(props) => props.theme.spacing[12]};
  padding-bottom: ${(props) => props.theme.spacing[20]};
`;
const StyledIcon = styled(Icon) `
  color: ${(props) => props.theme.color.primary[80]};
`;
const DarkText = styled.div `
  color: ${(props) => props.theme.color.neutral[100]};
  font: ${(props) => props.theme.typography.body.md.regular};
  display: inline;
`;
const LinkButton = styled(Button) `
  font: ${(props) => props.theme.typography.body.md.regular};
`;
const Content = styled.div `
  font: ${(props) => props.theme.typography.body.md.regular};
  color: ${(props) => props.theme.color.neutral[90]};
`;
const ContentTitle = styled.div `
  font: ${(props) => props.theme.typography.heading['2xl']};
  margin-bottom: ${(props) => props.theme.spacing[12]};
`;
const ImageWrapper = styled.div `
  color: ${(props) => props.theme.color.success[40]};
  padding: ${(props) => props.theme.spacing[12]};
`;
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 100%;
  gap: ${(props) => props.theme.spacing[16]};
  margin: ${(props) => props.theme.spacing[16]};
  margin-bottom: ${(props) => props.theme.spacing[96]};
`;
const PhoneNumber = styled.a `
  text-decoration: underline;
  display: inline;
  color: ${(props) => props.theme.color.primary[80]};
  font: ${(props) => props.theme.typography.body.md.semibold};
`;
AttendanceAllowanceSuccess.displayName = 'AttendanceAllowanceSuccess';
export default AttendanceAllowanceSuccess;
